import React from 'react';
import Login from '../Login/Login';

import './Auth.css';

export default function Auth() {
    return (
        <div className='AuthContainer'>
            <Login />
        </div>
    );
}
